import './input.min.js'
import './toast.js'
import './popover.js'
import './combobox.js'
import './collapse.js'
import './accordion.js'
import './tabs.js'
import './textarea.js'
import './fab.js'
import './workspace.js'
import './workspaceApp.js'
import './events.js'
import {registerFilterModal} from './filterModal.js'
import {hxConfirm} from './confirm.js'
import {getEl, getAllEl, domIsSettled, removeElementByID, formatNumber, handleFormEnter} from './dom.js'
import { TinyGesture } from './tinygesture.js'

window.hxConfirm = hxConfirm
window.removeElementByID = removeElementByID
window.handleFormEnter = handleFormEnter

window.$ = getEl
window.$$ = getAllEl
window.formatNumber = formatNumber
window.TinyGesture = TinyGesture

document.addEventListener('alpine:init', () => {
	if (window.Alpine) {
		registerFilterModal();
		window.Alpine.directive('gesture', (el, directive, utilities) => {
			const expression = directive.expression;
			const modifiers = directive.modifiers;
			const evaluateLater = utilities.evaluateLater;
			const effect = utilities.effect;

			const gesture = new TinyGesture(el, { mouseSupport: true });
			const evaluate = evaluateLater(expression);

			if (modifiers.includes('swipeleft')) {
				let startX = 0;
				let origTransform = el.style.transform || '';

				el.addEventListener('touchstart', (e) => {
					startX = e.touches[0].clientX;
					el.style.transition = 'none';
				}, { passive: true });

				el.addEventListener('touchmove', (e) => {
					let diff = e.touches[0].clientX - startX;
					if (diff < 0) {
						el.style.transform = `translateX(${Math.max(-100, diff)}px)`;
					}
				}, { passive: true });

				el.addEventListener('touchend', () => {
					el.style.transition = 'transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1)';
					el.style.transform = origTransform;
				}, { passive: true });

				gesture.on('swipeleft', (e) => {
					evaluate();
				});
			}

			if (modifiers.includes('longpress')) {
				gesture.on('longpress', (e) => {
					evaluate();
				});
			}
		});
	}
});

window.openDialog = openDialog
export function openDialog(id) {
	domIsSettled().then(() => {
		const $el = document.querySelector(`#${id}`)
		if ($el) {
			$el.showModal()
		}
	})
}

window.closeDialog = closeDialog
export function closeDialog(id) {
	domIsSettled().then(() => {
		const $el = document.querySelector(`#${id}`)
		if ($el) {
			$el.close()
		}
	})
}

// Add htmx-request class to all standard links to show loading indicator
document.addEventListener('click', (e) => {
	let link = e.target.closest('a[href]:not([target="_blank"])');
	if (link && !e.ctrlKey && !e.metaKey) {
		link.classList.add('htmx-request');
	}
});

// Global request state for top progress bar
document.addEventListener('htmx:beforeRequest', () => {
	document.body.classList.add('htmx-global-loading');
});
document.addEventListener('htmx:afterRequest', () => {
	document.body.classList.remove('htmx-global-loading');
});

// Redirect to login on 401 Unauthorized for standard web and desktop views
// (Telegram Mini App handles 401 recovery separately via telegram.min.js)
document.addEventListener('htmx:beforeSwap', (evt) => {
	if (evt.detail.xhr && evt.detail.xhr.status === 401 && !window.Telegram?.WebApp?.initData) {
		evt.detail.shouldSwap = false;
		const dest = window.location.pathname + window.location.search;
		let loginUrl = '/login?next=' + encodeURIComponent(dest);
		if (window.__SIRO_DESKTOP__ || document.cookie.includes('is_desktop=1')) {
			loginUrl += '&is_desktop=1';
		}
		window.location.href = loginUrl;
	}
});
